import React, { useState, useEffect, useRef } from 'react';
import './ReferenceTooltip.css';
import { useTranslation } from 'react-i18next';

const ReferenceTooltip = ({ reference, position }) => {
    const tooltipRef = useRef(null);
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (position && tooltipRef.current) {
            const tooltip = tooltipRef.current;
            const tooltipRect = tooltip.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const windowWidth = window.innerWidth;

            let top = position.top - tooltipRect.height - 10;
            let left = position.left - (tooltipRect.width / 2);

            // Ekran dışına taşma kontrolü
            if (top < 0) top = position.bottom + 10;
            if (left < 0) left = 10;
            if (left + tooltipRect.width > windowWidth) {
                left = windowWidth - tooltipRect.width - 10;
            }

            setTooltipPosition({ top, left });
        }
    }, [position]);

    if (!reference) return null;

    return (
        <div
            className="reference-tooltip"
            ref={tooltipRef}
            style={{
                top: tooltipPosition.top,
                left: tooltipPosition.left
            }}
        >
            <div className="reference-tooltip-content">
                <div className="reference-tooltip-header">
                    <h3>{reference.title}</h3>
                </div>
                <div className="reference-tooltip-body">
                    <p><strong>Authors:</strong> {reference.authors}</p>
                    <p><strong>Year:</strong> {reference.year}</p>
                    {reference.journal && (
                        <p><strong>Publisher:</strong> {reference.journal}</p>
                    )}
                    {reference.doi && (
                        <p>
                            <strong>DOI: </strong>
                            <a
                                href={reference.doi.startsWith('http') ? reference.doi : `https://doi.org/${reference.doi}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {reference.doi}
                            </a>
                        </p>
                    )}
                    {reference.summary && (
                        <div className="reference-tooltip-summary">
                            <p>{reference.summary}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReferenceTooltip;